import { useMemo } from "react";

import { FEEDBACK_FIXTURES } from "@/components/feedback/data/feedbackFixtures";
import {
  FeedbackFilters,
  FeedbackResponseRow,
  FeedbackResponsesQuery,
  FeedbackResponsesResult,
} from "@/components/feedback/types";

// EXTRACT: candidate hook signature for libs/ui — once the real API exists,
// the body swaps to a clientRs call without changing this shape.
export const useFeedbackResponses = (
  query: FeedbackResponsesQuery,
): FeedbackResponsesResult => {
  const { search, filters, page, pageSize } = query;

  return useMemo(() => {
    const filtered = FEEDBACK_FIXTURES.filter(
      (row) => matchesSearch(row, search) && matchesFilters(row, filters),
    );
    const start = page * pageSize;
    return {
      rows: filtered.slice(start, start + pageSize),
      total: filtered.length,
      isLoading: false,
    };
  }, [search, filters, page, pageSize]);
};

const matchesSearch = (
  row: FeedbackResponseRow,
  search: string | undefined,
): boolean => {
  if (!search) {
    return true;
  }
  const needle = search.toLowerCase();
  return (
    row.id.toLowerCase().includes(needle) ||
    row.user_display_name.toLowerCase().includes(needle) ||
    row.intended_group.toLowerCase().includes(needle) ||
    row.agency.toLowerCase().includes(needle)
  );
};

const matchesFilters = (
  row: FeedbackResponseRow,
  filters: FeedbackFilters,
): boolean => {
  if (
    filters.collectionId &&
    row.feedback_collection_id !== filters.collectionId
  ) {
    return false;
  }
  if (filters.submitStartDate) {
    if (new Date(row.time_submitted) < new Date(filters.submitStartDate)) {
      return false;
    }
  }
  if (filters.submitEndDate) {
    if (new Date(row.time_submitted) > new Date(filters.submitEndDate)) {
      return false;
    }
  }
  return true;
};
